import React, { useEffect, useState, useContext } from "react";
// import { Amplify } from "aws-amplify";
import { Auth } from "aws-amplify";
// import style from "./style.css";
// mui
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/CustomInput";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
} from "@mui/material";
import theme from "../../global-styles/theme";
import { appLogger, Http } from "../../utils";
// import { useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import NewPassword from "./NewPassword";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { useNavigate } from "react-router-dom";
import images from "../../global-styles/images";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import ForgotPassword from "./ForgotPassword";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import OrganisationForm from "./OrganisationForm";
import { AuthDetails } from "../../model";
import { roleConfig } from "../../utils/config/role-config";
import ReCAPTCHA from "react-google-recaptcha";
import { enableRecaptcha, reCaptchaSiteKey } from "../../utils/config";
import { CheckCaptchValid, reCaptchaMandatoryMessage } from "../../utils/data";

const recap_siteKey = reCaptchaSiteKey;

const env = process.env.REACT_APP_STAGE;

const initialValues = {
  email: "",
  password: "",
  // recaptcha: "",
};

const validationSchema = Yup.object({
  email: Yup.string().email("Email is invalid").required("Email is required"),
  password: Yup.string().required("Password is required"),
  // recaptcha: Yup.string().required("Captcha is required"),
});

declare global {
  interface Window {
    Cuvo: any;
    grecaptcha: {
      render(
        arg0: string,
        arg1: { sitekey: { reCaptchaSiteKey: string }; size: string }
      ): unknown;
      enterprise: {
        ready(callback: () => any): any;
        execute(siteKey: string, options: any): any;
        // Add other methods or properties as needed
      };
      // Add other methods or properties as needed
    };
  }
}

const Home = (props: any) => {
  const navigate = useNavigate();

  // const setSysDetails = useActions(setSystemDetails);
  // const stateVariable = useSelector((state: IRootState) => state);
  // const saveUserData = useActions(saveUserDetails);
  const [email, setEmail] = useState("");
  const [newSignInUser, setNewSignInUser] = useState(undefined);
  const [newOrgUser, setNewOrgUser] = useState(undefined);
  const [newPassword, setNewPassword] = useState(false);
  const [newPasswordType, setNewPasswordType] = useState("");
  const [errorMsg, setErrorMsg] = useState(false);
  const [forgetPwdCheck, setForgetPwdCheck] = useState(false);
  const [serverErrorShow, setServerErrorShow] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [organisationForm, setOrganisationForm] = useState(false);
  const { setIsOrgCompleted } = props;

  const { userInfo, setUserInfo, setIsAuthenticated, setcontextProVersion } =
    useContext(UserContext) as UserLoginInfo;

  const userInfoDetail = { user: userInfo };
  appLogger.info({
    infoObj: {
      method: "useFormik",
      component: "home",
      fileName: "index.tsx",
      userInfoDetail: userInfoDetail,
    },
  });

  useEffect(() => {
    Http.get({
      url: "/api/v2/organizations/0",
      customHeaders: { noauthvalidate: "true" },
    })
      .then((response: any) => {
        appLogger.info({
          infoObj: {
            method: "useFormik",
            component: "home",
            fileName: "index.tsx",
            orgListResponse: response,
          },
        });
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "useFormik",
            component: "home",
            fileName: "index.tsx",
            err: error,
          },
        });
        setServerErrorShow(true);
      });
  }, []);

  useEffect(() => {
    if (props.type == "OrgCompleted") {
      setOrganisationForm(true);
    }
  }, [organisationForm]);
  const recap_action = "LOGIN";

  // useEffect(() => {
  //   const loadReCaptcha = async () => {
  //     // Execute reCAPTCHA when the script is loaded
  //     await window.grecaptcha.enterprise.ready(function () {
  //       window.grecaptcha.render("submit", {
  //         "sitekey": { reCaptchaSiteKey },
  //         "size": "invisible",
  //       });
  //       window.grecaptcha.enterprise
  //         .execute(recap_siteKey, {
  //           action: recap_action,
  //         })
  //         .then(function (token: any) {
  //           // Handle the reCAPTCHA token
  //           if (token) {
  //             console.log(token, "kkkk");
  //             // Call your backend API to verify the reCAPTCHA token
  //             // Handle the form submission logic here
  //           } else {
  //             console.error("Captcha verification failed");
  //           }
  //         })
  //         .catch(function (error: any) {
  //           console.error("Error executing reCAPTCHA:", error);
  //         });
  //     });
  //   };

  //   // Load reCAPTCHA script dynamically
  //   const script = document.createElement("script");
  //   script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recap_siteKey}`;
  //   script.async = true;
  //   document.head.appendChild(script);

  //   // Execute reCAPTCHA when the script is loaded
  //   script.onload = loadReCaptcha;

  //   // Cleanup: Remove the script from the DOM when the component is unmounted
  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, [recap_siteKey, recap_action]);

  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    let script: any;
    const style = document.createElement("style");
    // Define your CSS rules
    const cssRules = `
      .grecaptcha-badge {
        visibility: hidden;
  opacity: 0;
  width: 1px !important;
  height: 1px !important;
      }
    `;

    // Add CSS rules to the style element
    style.appendChild(document.createTextNode(cssRules));

    // Append the style element to the document head
    document.head.appendChild(style);
    const loadScript = () => {
      script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recap_siteKey}`;
      script.async = true;
      script.defer = true;
      script.id = "login";

      script.onload = () => setScriptLoaded(true);
      document.body.appendChild(script);
    };
    loadScript();
    return () => {
      // const scriptElem: any = document.getElementById("SOME_ID");
      // scriptElem.remove();
      if (scriptLoaded) {
        document.body.removeChild(script);
      }
    };
  }, [scriptLoaded]);

  const handleSubmit = async (values: any) => {
    setErrorMsg(false);
    setIsloading(true);
    if (enableRecaptcha) {
      await window.grecaptcha.enterprise.ready(function () {
        window.grecaptcha.enterprise
          .execute(recap_siteKey, {
            action: "LOGIN",
          })
          .then(function (token: any) {
            // Handle the reCAPTCHA token
            if (token) {
              setIsloading(true);
              // Call your backend API to verify the reCAPTCHA token
              // Handle the form submission logic here
              Http.post({
                url: `/api/v2/recaptcha`,
                customHeaders: { noauthvalidate: "true" },
                state: userInfo,
                body: {
                  token: token,
                  expectedAction: "LOGIN",
                },
              })
                .then(async (response: any) => {
                  setIsloading(false);
                  const checkValidData: any = CheckCaptchValid(
                    response?.message
                  );
                  if (checkValidData) {
                    const parsedData = JSON.parse(checkValidData);
                    if (parsedData && parsedData.valid) {
                      confirmLoginAuth(values);
                    } else {
                      props.snackbarShowMessage(
                        "Captcha verification failed",
                        "error"
                      );
                    }
                  } else {
                    props.snackbarShowMessage(
                      "Captcha verification failed",
                      "error"
                    );
                  }
                })
                .catch((error) => {
                  appLogger.error({
                    errObj: {
                      method: "regenerateApiKey",
                      component: "login",
                      fileName: "home.tsx",
                      err: error,
                    },
                  });
                  setIsloading(false);
                });
            } else {
              setIsloading(false);
              props.snackbarShowMessage("Captcha verification failed");
            }
          })
          .catch(function (error: any) {
            setIsloading(false);
            props.snackbarShowMessage("Error executing reCAPTCHA:", "error");
          });
      });
    } else {
      confirmLoginAuth(values);
    }
  };
  const confirmLoginAuth = async (values: any) => {
    try {
      appLogger.info({
        infoObj: {
          method: "handleSubmit",
          component: "home",
          fileName: "index.tsx",
          userInfo: values,
        },
      });
      setEmail(values?.email);
      setIsloading(true);
      const user = await Auth.signIn(
        values?.email.toLowerCase(),
        values?.password
      );
      if (user && user.challengeName === "NEW_PASSWORD_REQUIRED") {
        setIsloading(false);
        setNewSignInUser(user);
        setNewPassword(true);
        setNewPasswordType("new");
        // setLoading(false);
      } else if (
        user &&
        user.signInUserSession.idToken &&
        user.signInUserSession.accessToken
      ) {
        handleSuccessfulSignIn(user);
      }
    } catch (error) {
      if (error instanceof Error) {
        // ✅ TypeScript knows error is Error
        appLogger.error({
          errObj: {
            method: "handleSubmit",
            component: "home",
            fileName: "index.tsx",
            err: error,
          },
        });
        props.snackbarShowMessage(error.message, "error");
        setIsloading(false);
      } else {
        props.snackbarShowMessage("Unexpected error", "error");
        appLogger.error(
          {
            infoObj: {
              method: "handleSubmit",
              component: "home",
              fileName: "index.tsx",
            },
          },
          "Unexpected error"
        );
      }
    }
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnBlur: true,
    onSubmit: handleSubmit,
  });
  const handleRecaptchaChange = (value: any) => {
    formik.setFieldValue("recaptcha", value);
    // formik.setFieldTouched("recaptcha", true);
  };
  const handleCaptchaExpired = () => {
    formik.setFieldValue("recaptcha", "");
  };
  const handleClickShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleRole = (userDetails: any) => {
    for (const key in roleConfig) {
      if (userDetails.userRole == roleConfig[key]) {
        return key;
      }
    }
  };

  const handleSuccessfulSignIn = (user: any) => {
    const tokenInfo: any = jwtDecode(user.signInUserSession.idToken.jwtToken);
    const userData: any = {};
    userData.email = tokenInfo["email"];
    userData.guid = tokenInfo["username"];

    appLogger.info({
      infoObj: {
        method: "handleSuccessfulSignIn",
        component: "home",
        fileName: "index.tsx",
        user: user,
      },
    });

    localStorage.setItem("authToken", user.signInUserSession.idToken.jwtToken);
    setNewOrgUser(user);
    // saveUserData({
    //   isAuthenticated: true,
    //   idToken: user?.signInUserSession?.idToken?.jwtToken,
    //   accessToken: user.signInUserSession.accessToken,
    //   userDetails: jwtDecode(user.signInUserSession.idToken.jwtToken),
    //   team:
    //     tokenInfo["custom:teamName"] && tokenInfo["custom:teamName"] !== ""
    //       ? tokenInfo["custom:teamName"]
    //       : "Others",
    //   roles: ["Member"],
    // });
    // if (typeof window !== "undefined") {
    // if (typeof window.GigaTester !== "undefined") {
    //   window.GigaTester.setUserDetails(userData);
    //   // window.GigaTester.setDefaultCategory("Admin-Bug", "BUGS");
    //   // window.GigaTester.setDefaultCategory("Admin", "FEEDBACK");
    // }
    // }

    Http.get({
      url: `/api/v2/users/login`,
      // state: userStateVariable,
    })
      .then((response: any) => {
        if (response) {
          props.snackbarShowMessage("Login Successfully", "success");
          if (response.userDetails.userRole.length > 0) {
            response.userDetails.userRole =
              handleRole(response.userDetails) || "";
          }
          const obj: AuthDetails = {
            isAuthenticated: true,
            idToken: user.signInUserSession.idToken.jwtToken,
            accessToken: user.signInUserSession.accessToken,
            userDetails: response.userDetails,
            isSsoUser: false,
          };
          setUserInfo(obj);
          setIsAuthenticated(true);
          setIsloading(false);
          setcontextProVersion([]);
          appLogger.info({
            infoObj: {
              method: "handleSuccessfulSignIn",
              component: "home",
              fileName: "index.tsx",
              userInfo: userInfo,
            },
          });
          if (
            response &&
            response.userDetails &&
            response.userDetails &&
            response.userDetails.orgId &&
            response.userDetails.orgId != ""
          ) {
            localStorage.setItem("userOrgId", response.userDetails.orgId);
            handleFetchEnabledFeatures(response.userDetails.orgId);
            navigate("/dashboard");
          } else {
            appLogger.info(
              {
                infoObj: {
                  method: "handleSuccessfulSignIn",
                  component: "home",
                  fileName: "index.tsx",
                },
              },
              "setOrganisationForm"
            );
            setOrganisationForm(true);
          }
          // route("/feedback"); // appends a history entry

          // setUserInfo({
          //   isAuthenticated: true,
          //   idToken: user.signInUserSession.idToken.jwtToken,
          //   accessToken: user.signInUserSession.accessToken,
          //   userDetails: jwtDecode(user.signInUserSession.idToken.jwtToken),
          //   // team:
          //   //   tokenInfo["custom:teamName"] &&
          //   //   tokenInfo["custom:teamName"] !== ""
          //   //     ? tokenInfo["custom:teamName"]
          //   //     : "Others",
          //   // roles: response.values.roles,
          // });
          // if (response.values.roles.length) {
          //   if (
          //     response.values.roles.includes('Admin') ||
          //     response.values.roles.includes('Manager')
          //   ) {
          //     // setLoading(false);
          //     // return history.push('/admin'), setLoading(true), closeDialog();
          //   } else {
          //     // setLoading(false);
          //     // return history.push('/admin'), setLoading(true), closeDialog();
          //   }
          // }
        }
      })
      .catch((error: any) => {
        appLogger.error({
          errObj: {
            method: "handleSuccessfulSignIn",
            component: "home",
            fileName: "index.tsx",
            err: error,
          },
        });
        setIsloading(false);
      });
  };
  const handleFetchEnabledFeatures = async (id: string) => {
    setIsloading(true);
    try {
      const res: any = await Http.get({
        url: `/api/v2/organizations/${id}`,
      });
      if (
        res?.organizationDetails &&
        res?.organizationDetails.enabledFeatures &&
        Object.keys(res?.organizationDetails.enabledFeatures).length > 0
      ) {
        const { enabledFeatures } = res?.organizationDetails;
        localStorage.setItem(
          "userenabledFeatures",
          JSON.stringify(enabledFeatures)
        );
      }
      setIsloading(false);
    } catch (err) {
      appLogger.error({
        errObj: {
          method: "fetchGroup",
          component: "add-product",
          fileName: "basicDetails.tsx",
          err: err,
        },
      });
      props.snackbarShowMessage(
        "Failed fetching enabled features",
        "error",
        3000
      );
      setIsloading(false);
    }
  };
  const onForgotPassword = () => {
    const getEmail = { ...formik.getFieldProps("email") };
    appLogger.info({
      infoObj: {
        method: "onForgotPassword",
        component: "home",
        fileName: "index.tsx",
        email: getEmail,
      },
    });
    if (getEmail.value && getEmail.value.length > 0 && !formik.errors.email) {
      setIsloading(true);
      Auth.forgotPassword(getEmail.value)
        .then((data) => {
          setForgotPassword(true);
          setIsloading(false);
        })
        .catch((e) => {
          setIsloading(false);
          switch (e.message) {
            case "Username/client id combination not found.":
              props.snackbarShowMessage("Email is not registered", "error");
              break;
            case "Password did not conform with policy: Password not long enough":
              props.snackbarShowMessage(e.message, "error");
              break;
            case "User password cannot be reset in the current state.":
              props.snackbarShowMessage(
                "Email Verification is pending, Check your email inbox",
                "error"
              );
              break;
            case "Incorrect username or password.":
              props.snackbarShowMessage(e.message, "error");
              break;
            case "User does not exist.":
              props.snackbarShowMessage(e.message, "error");
              break;
            default:
              props.snackbarShowMessage("Error in Forgot password", "error");
          }
        });
    } else {
      // setIsloading(false);
      setForgetPwdCheck(true);
    }
  };
  const setLoginPage = () => {
    setNewPassword(false);
    setForgotPassword(false);
    setServerErrorShow(false);
  };

  const handleEmailChange = (event: any) => {
    if (event.target.value) {
      formik.setTouched({}, false);
      setForgetPwdCheck(false);
    }
  };
  function onSubmit(token: any) {
    alert("thanks " + token);
  }
  return (
    <Box
      component="div"
      className={isLoading ? "loader auth-form" : "auth-form"}
    >
      {/* <Helmet>
        <script
          src="https://www.google.com/recaptcha/enterprise.js?render=6LftCVMpAAAAAD1XJVAoBJkjZDVXP8U_dLO8L92A"
          async
        ></script>
      </Helmet> */}
      <Container component="div" className="form-container">
        <Box className="logo-wrap">
          <img src={images.logoBlack} alt="Cuvo Logo" />
        </Box>

        {serverErrorShow ? (
          <Box sx={{ my: 5 }}>
            <Typography className="error-msg text-center">
              Internal server error
            </Typography>
          </Box>
        ) : (
          ""
        )}

        {!serverErrorShow &&
        !newPassword &&
        !forgotPassword &&
        !organisationForm ? (
          <Box className="form-wrap">
            <Typography component="h1" variant="h5">
              Login
            </Typography>
            {/* {errorMsg && (
                <Typography className="error-msg">
                  Incorrect username or password
                </Typography>
              )} */}
            <Box
              component="form"
              onSubmit={formik.handleSubmit}
              method="post"
              noValidate
            >
              <CustomInput
                id="email"
                autoComplete="email"
                placeholder="Enter Email"
                label="Email Id"
                autoFocus={true}
                startAdornment={
                  <InputAdornment position="start">
                    <img src={images.email} />
                  </InputAdornment>
                }
                {...formik.getFieldProps("email")}
                value={formik.values.email}
                onChange={(event) => {
                  formik.handleChange(event);
                  handleEmailChange(event);
                }}
                error={
                  ((formik.values.email && formik.touched.email) ||
                    forgetPwdCheck) &&
                  formik.errors.email
                    ? true
                    : false
                }
                helperText={
                  ((formik.values.email && formik.touched.email) ||
                    forgetPwdCheck) &&
                  formik.errors.email
                    ? forgetPwdCheck && !formik.values.email
                      ? "Email is required for Forget Password"
                      : formik.errors.email
                    : null
                }
              />
              {/* <InputLabel>Password</InputLabel> */}
              <CustomInput
                type={passwordVisible ? "text" : "password"}
                id="password"
                placeholder="Enter Password"
                label="Password"
                autoComplete="current-password"
                startAdornment={
                  <InputAdornment position="start">
                    <img src={images.password} />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      // onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {passwordVisible ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                {...formik.getFieldProps("password")}
                value={formik.values.password}
                onChange={(event) => {
                  formik.handleChange(event);
                  handleEmailChange(event);
                }}
                error={
                  !formik.values.password &&
                  !forgetPwdCheck &&
                  formik.touched.password &&
                  formik.errors.password
                    ? true
                    : false
                }
                helperText={
                  !formik.values.password &&
                  !forgetPwdCheck &&
                  formik.touched.password &&
                  formik.errors.password
                    ? formik.errors.password
                    : null
                }
              />

              {/* <FormControlLabel
                control={<Checkbox value="allowExtraEmails" color="primary" />}
                className="remember-label"
                label="Remember me"
              /> */}
              {/* <div
                id="recaptcha"
                className="g-recaptcha"
                data-sitekey={reCaptchaSiteKey}
                  data-callback={onSubmit}
                data-size="invisible"
              ></div> */}
              {reCaptchaMandatoryMessage()}

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: "15px",
                  mb: "15px",
                  backgroundColor: (theme: any) => theme.palette.primary.main,
                  textTransform: "uppercase",
                }}
                disabled={!(formik.isValid && formik.dirty)}
              >
                Login
              </Button>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Link
                  variant="body2"
                  sx={{
                    color: theme.palette.primary.main,
                    textDecoration: "none",
                  }}
                  className="forgot-link"
                  onClick={onForgotPassword}
                >
                  Forgot Password?
                </Link>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                  className="signup-link"
                >
                  <Typography component="p">
                    Don't have an account yet?
                  </Typography>

                  <Link
                    href="/sign-up"
                    color="secondary"
                    sx={{
                      color: theme.palette.primary.main,
                      textDecoration: "none",
                    }}
                  >
                    {"Sign Up"}
                  </Link>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <>
            {!serverErrorShow && !forgotPassword && !organisationForm && (
              <NewPassword
                type={newPasswordType}
                email={email}
                user={newSignInUser}
                handleSignIn={handleSuccessfulSignIn}
              />
            )}
          </>
        )}
        {!serverErrorShow && !newPassword && forgotPassword && (
          <>
            <ForgotPassword
              type="forgot"
              email={{ ...formik.getFieldProps("email") }}
              user={newSignInUser}
              handleSignIn={handleSuccessfulSignIn}
              setLoginPage={setLoginPage}
            />
          </>
        )}
        {!serverErrorShow &&
          !newPassword &&
          !forgotPassword &&
          organisationForm && (
            <OrganisationForm
              type="organisationform"
              email={{ ...formik.getFieldProps("email") }}
              setIsOrgCompleted={setIsOrgCompleted}
              handleSignIn={handleSuccessfulSignIn}
            />
          )}
      </Container>
    </Box>
  );
};

export default withSnackbar(Home);
